import { render, staticRenderFns } from "./text-box.vue?vue&type=template&id=026d02f8&scoped=true&"
import script from "./text-box.vue?vue&type=script&lang=ts&"
export * from "./text-box.vue?vue&type=script&lang=ts&"
import style0 from "./text-box.vue?vue&type=style&index=0&id=026d02f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d02f8",
  null
  
)

export default component.exports